import * as React from 'react'
import {
  TranslatableFields,
  Edit,
  SimpleForm,
  TextInput,
  BooleanInput,
  useGetIdentity,
  NumberField,
  TextField,
} from 'react-admin'
import { Typography, Box } from '@material-ui/core'

const ThematicEdit = props => {
  const { identity, loading: identityLoading } = useGetIdentity()
  if (identityLoading) return <>Loading...</>

  return (
    <Edit {...props}>
      <SimpleForm>
        <Box mb={2}>
          <Typography variant="body2" color="textSecondary">
            Actualiza los textos por idioma y el estado de la tematica.
          </Typography>
        </Box>
        <NumberField source="id" disabled />
        <BooleanInput source="status" />
        <TranslatableFields
          locales={['es', 'en', 'it', 'fr']}
          defaultLocale={identity.country.toLowerCase()}
          source="label"
        >
          <TextInput fullWidth source="label" />
        </TranslatableFields>
        <TextField source="country" disabled />
      </SimpleForm>
    </Edit>
  )
}

export default ThematicEdit
